export class Branding {
  public pageTitle: string;
  public pageSubtitle?: string;
  public themeName: string;

  constructor(pageTitle: string, themeName: string) {
    this.pageTitle = pageTitle;
    this.themeName = themeName;
  }
}

export const DefaultBranding = new Branding('Neotel Portal', 'neotel');
